<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import SalesDeliverySignatureContent from '../components/SalesDeliverySignatureContent.vue';
import { useSalesDeliverySignature } from '../composables/useSalesDeliverySignature';
import { salesIndexLocation } from '../composables/useSalesRouteState';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const id = computed(() => route.params.salesTransactionId);
const signature = useSalesDeliverySignature({ id, t, notify: useAlert });
const headerSubtitle = computed(() =>
  [
    signature.transaction.value?.title,
    signature.transaction.value?.address?.endereco,
  ]
    .filter(Boolean)
    .join(' · ')
);

const goBack = () =>
  router.push(
    salesIndexLocation({
      accountId: route.params.accountId,
      query: route.query,
      fallbackList: 'entregues',
    })
  );

const handleUpdated = action => {
  if (action === 'cancel') return goBack();
  return signature.load();
};
</script>

<template>
  <div class="min-h-full bg-lais-bg-soft">
    <LaisHeader
      :title="t('SALES.DELIVERY.CHECKOUT.HEADER_TITLE')"
      :subtitle="headerSubtitle || t('SALES.DELIVERY.CHECKOUT.HEADER_SUBTITLE')"
      :breadcrumb="[
        { label: t('SALES.TITLE') },
        { label: t('SALES.DELIVERY.CHECKOUT.TITLE') },
      ]"
      show-back
      :back-label="t('SALES.ACTIONS.BACK')"
      @back="goBack"
    />
    <div
      v-if="signature.loading.value && !signature.transaction.value"
      class="mx-auto max-w-[1080px] px-4 py-12 text-center text-sm text-lais-text-muted sm:px-6 lg:px-10"
    >
      {{ t('SALES.DELIVERY.CHECKOUT.LOADING') }}
    </div>
    <div
      v-else-if="signature.loadError.value"
      class="mx-auto max-w-[1080px] px-4 py-12 text-center text-sm text-lais-text-muted sm:px-6 lg:px-10"
    >
      {{ t('SALES.DELIVERY.CHECKOUT.ERRORS.LOAD') }}
    </div>
    <SalesDeliverySignatureContent
      v-else
      :can-manage="signature.canManage.value"
      :integration="signature.integration.value"
      :loading="signature.loading.value"
      :property-offer-id="signature.propertyOfferId.value"
      :resending-signer-reference="signature.resendingSignerReference.value"
      @refresh="signature.load"
      @resend-signer="signature.resendSigner"
      @updated="handleUpdated"
    />
  </div>
</template>
